import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Sparkles } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(() => {
    if (typeof window === 'undefined') return 72;
    const saved = sessionStorage.getItem('chikung-spots');
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 45) * 1;
      return Math.min(value + increment, 94);
    }
    return 72;
  });
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem('chikung-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 94) return prev;
        const increment = Math.random() < 0.3 ? 1 : 0;
        return Math.min(prev + increment, 94);
      });
    }, 30000 + Math.random() * 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-brand-purpleDark text-brand-surface border-b border-brand-gold/40" data-id="element-290" data-mp="2ccrjudu8zfzt">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-291" data-mp="151srl7zx1pic">
        <div className="md:hidden overflow-hidden relative" data-id="element-292" data-mp="10yea0cwbx12s">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-293" data-mp="1110h6bfb5ekh">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-294" data-mp="xf5f24ax9dks">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-295" data-mp="joactauxhuq6">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-296" data-mp="oga64kghtpds" />
                  <span data-id="element-297" data-mp="ohv64plku0j1">Precio de lanzamiento cierra en</span>
                  <span className="font-display font-semibold tabular-nums bg-brand-surface/15 rounded-sm px-1.5 py-0.5 ml-0.5 text-brand-surface" data-id="element-298" data-mp="9sp6j0itu8am">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-299" data-mp="4skqtcpqthlg" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-300" data-mp="3i8vbtzlfgxje">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-goldLight" data-id="element-301" data-mp="3ib94k1smxxns"></span>
                  <span data-id="element-302" data-mp="3dbwez9adqchi">
                    <strong className="tabular-nums text-brand-goldLight" data-id="element-303" data-mp="3r9tgmk3ox931">
                      {spotsTaken}%
                    </strong>{' '}
                    de cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-304" data-mp="51tisfugzkky" />
                <a href="#pricing" className="inline-flex items-center gap-1 bg-brand-goldLight text-brand-purpleDark font-display font-semibold uppercase tracking-[0.14em] px-2.5 py-0.5 rounded-sm text-[10px] shrink-0" data-id="element-305" data-mp="41rno1ng2ht">
                  Ver kit
                </a>
              </div>)}
          </motion.div>
        </div>

        <div className="hidden md:flex items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm font-medium" data-id="element-306" data-mp="iu9pbqmky0qm">
          <div className="flex items-center gap-1.5 md:gap-2 whitespace-nowrap text-brand-goldLight" data-id="element-307" data-mp="12wxjsw6vlnt9">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" data-id="element-308" data-mp="16wxvi92lbkwm" />
            <span data-id="element-309" data-mp="1bofwgx4m5lhl">PRECIO DE LANZAMIENTO CIERRA EN:</span>
            <span className="font-display font-semibold tabular-nums bg-brand-surface/15 rounded-sm px-1.5 py-0.5 ml-0.5 text-brand-surface" data-id="element-310" data-mp="1bozhwnth2s0d">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="hidden md:block w-px h-4 bg-brand-goldLight/40 shrink-0" data-id="element-311" data-mp="nyvae5d5y843" />
          <div className="hidden md:flex items-center gap-2 whitespace-nowrap" data-id="element-312" data-mp="o0okjumzjagu">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-goldLight" data-id="element-313" data-mp="swn5175708bz"></span>
            <span data-id="element-314" data-mp="xxufjdypzlmc">
              <strong className="tabular-nums text-brand-goldLight" data-id="element-315" data-mp="xycewjgoifyh">
                {spotsTaken}%
              </strong>{' '}
              de cupos tomados
            </span>
          </div>
          <a href="#pricing" className="hidden sm:inline-flex items-center gap-1 bg-brand-goldLight text-brand-purpleDark font-display font-semibold uppercase tracking-[0.14em] px-3 py-1 rounded-sm text-[10px] md:text-xs hover:bg-brand-gold transition-colors duration-200 ease-out shrink-0" data-id="element-316" data-mp="29adaah81t2n7">
            Ver kit
          </a>
        </div>
      </div>
    </div>;
}